import React from "react";

const BeautyAndCosmetics: React.FC = () => {
  return (
    <main className="min-h-screen w-full bg-gray-100">
      <div className="w-full mx-auto px-6 py-20 max-w-full">
        {/* Beauty & Cosmetics Background Banner with centered text overlay */}
        <div className="w-full mb-12 relative flex items-center justify-center">
          <img
            src={`${process.env.PUBLIC_URL}/images/makeupbg.jpeg`}
            alt="Beauty & Cosmetics Background"
            className="w-full h-40 object-cover rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-lg md:text-2xl font-semibold text-center text-[#0f145b]">
              Affordable and high-end makeup and skin care brands.
            </span>
          </div>
        </div>
        <div className="flex flex-row justify-center items-center gap-4 mb-12">
          <a
            href="https://inimexshop.com/en/collections/misslyn"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 max-w-[120px] sm:max-w-[160px] md:max-w-[200px]"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/misslyn.svg`}
              alt="Misslyn"
              className="w-full h-24 sm:h-32 md:h-40 object-contain hover:opacity-80 transition p-2 sm:p-4 rounded-lg"
            />
          </a>
          <a
            href="https://inimexshop.com/en/collections/make-up-factory"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 max-w-[120px] sm:max-w-[160px] md:max-w-[200px]"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/makeup.svg`}
              alt="Make-up Factory"
              className="w-full h-24 sm:h-32 md:h-40 object-contain hover:opacity-80 transition p-2 sm:p-4 rounded-lg"
            />
          </a>
          <a
            href="https://inimexshop.com/en/collections/maluwilz"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 max-w-[120px] sm:max-w-[160px] md:max-w-[200px]"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/maluwilz.svg`}
              alt="Malu Wilz"
              className="w-full h-24 sm:h-32 md:h-40 object-contain hover:opacity-80 transition p-2 sm:p-4 rounded-lg"
            />
          </a>
        </div>
        {/* Misslyn1 full-width responsive image */}
        <div className="w-full mb-0">
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={`${process.env.PUBLIC_URL}/images/misslynlaptop.jpeg`}
            />
            <source
              media="(min-width: 640px)"
              srcSet={`${process.env.PUBLIC_URL}/images/misslyntablet.jpeg`}
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/misslynmobile.jpeg`}
              alt="Misslyn Banner"
              className="w-full h-[30rem] object-contain rounded-lg bg-white"
              style={{ objectPosition: "center" }}
            />
          </picture>
        </div>
      </div>
    </main>
  );
};

export default BeautyAndCosmetics;
